module.exports = __webpack_public_path__ + "img/splashscreenv2.16ac8fd.png";